import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { invoiceTransactionCommand } from '../../command/transaction-invoice';
import { InvoiceTransactionsExportCommandHandler } from './export-invoices-transactions-command-handler.service';

@Injectable()
export class InvoiceTransactionCommandHandlerResolver extends CommandHandlerResolver {
  constructor(invoicesExportHandler: InvoiceTransactionsExportCommandHandler) {
    super();
    this.addHandler(invoiceTransactionCommand.export, invoicesExportHandler);
  }
}
